export default __webpack_public_path__ + "static/pes-fa049a4e2c58a272d6008ff1fe29e134.webp";